export const APP_VERSION = {
  dateTime: "2026-08-18T23:54:44+08:00",
  label: "2026.08.18 23:54",
} as const;

/** 最新一份日期化学习内容种子的版本。 */
export const CONTENT_VERSION = "2026-08-21" as const;

/** 页脚与完整备份共用的版本元数据，禁止在调用处重复填写。 */
export const BACKUP_VERSION = {
  appVersion: APP_VERSION.label,
  contentVersion: CONTENT_VERSION,
} as const;
